module.exports = __webpack_public_path__ + "img/SES_140250018.2d319a85.jpg";